import { INoEditPlugin } from '@src/slide/application/no-edit/plugins/no-edit-plugin.interface';
import { INoEditService } from '@src/slide/application/no-edit/service/no-edit-service/no-edit-service.interface';
import { IBaseExtensionService } from '@src/slide/application/service/edit-extension/core/base/interface';

export type PluginProps = {
    noEditService?: INoEditService,
    extensionService?: IBaseExtensionService,
};


export abstract class NoEditPlugin implements INoEditPlugin {
    public static pluginTag = 0;  // 标记是class

    protected props: PluginProps;

    protected noEditService?: INoEditService;
    protected editExtensionService?: IBaseExtensionService;

    public constructor(pluginProps: PluginProps) {
        this.props = pluginProps;

        this.noEditService = pluginProps.noEditService;
        this.editExtensionService = pluginProps.extensionService;
    }

    public hide(options?: unknown): void {
        // 子类实现
    }

    public show(options?: unknown): void {
        // 子类实现
    }

    public dispose(): void {
        // 子类可以继承重写
    }

    public abstract initPlugin(): void;
}
